module.exports = __webpack_public_path__ + "bermuda.svg?a4498a96a86015e7ba1d8e44362257f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/bermuda.svg
// module id = 111
// module chunks = 10